<template lang="html">
   <form :class="class_binding" @submit.prevent="submitForm()" @keyup.enter="submitForm()">
      <div class="form-content" :class="form.class" v-for="form in forms">
         <label 
            v-if="form.label && form.type !== 'checkbox' && form.type != 'button' && form.type != 'upload' && !form.hide_label"
            class="form-label"
         > 
            <span v-html="form.label"></span> 
            <span class="red" v-show="form.validation && form.validation.includes('required')">*</span>
         </label>
         <label 
            v-if="form.type !== 'checkbox' && form.type != 'button' && form.type != 'upload' && form.sub_label"
            class="small-label" v-html="form.sub_label" 
         ></label>
         
         <InputText
            v-if="form.type === 'text'"
            :name="form.model"
            :prepend="form.prepend"
            :append="form.append"
            :type="form.form_type"
            :model="form_data_[form.model]"
            v-model="form_data_[form.model]"
            :action="form.name"
            :disabled="form.disabled"
            :placeholder="form.placeholder"
            @input="validateItem(form)"
         />

         <Select 
            v-if="form.type === 'select'"
            v-model="form_data_[form.model]" 
            :disabled="form.disabled" 
            :multiple="form.multiple || false" 
            :clearable="form.clearable || true" 
            :filterable="form.filterable || false"
            :max-tag-count="form.max_tag_count || 3"
            :placeholder="form.placeholder"
            @on-query-change="handleRemote($event,form)"
            @input="onSelectChange(form)"
         >
            <Option v-for="(item,index) in form.options" :value="item.val" :key="index">{{ item.label }}</Option>
         </Select>

         <Mobile 
            v-if="form.type === 'mobile'"
            v-model="form_data_[form.model]"
            @input="validateItem(form)"
            :placeholder="form.placeholder"
         />

         <button 
            v-if="form.type === 'button'"
            class="btn form-btn" 
            :class="form.btnClass"
            @click="btnClick(form.model)"
            v-html="form.label"
         ></button>

         <TextArea
            v-if="form.type === 'textarea'"
            :name="form.model"
            :model="form_data_[form.model]"
            v-model="form_data_[form.model]"
            :action="form.name"
            :rows="form.rows"
            :placeholder="form.placeholder"
            @input="validateItem(form)"
         />

         <Checkbox
            v-if="form.type === 'checkbox'"
            :name="form.model"
            v-model="form_data_[form.model]"
            :action="form.name"
            :label="form.label"
            @change="validateItem(form)"
         />

         <!-- TODO Bug fix to allow setting switch type to round and various sizes -->
         <SwitchComponent 
            v-if="form.type === 'switch'"
            :checked="form_data_[form.model]" 
            :size="form.size || ''" 
            :disabled="form.disabled"
            @change="validateItem(form)"
         />

         <DatePicker 
            v-if="form.type === 'datepicker'"
            :type="form.form_type || 'date'" 
            :value="form_data_[form.model]" 
            :format="form.format || 'dd-MM-yyyy'" 
            :placement="form.placement || 'bottom-end'" 
            :placeholder="form.placeholder"
            :start-date="form.start_date || new Date()"
            @on-change="handleChange($event,form)">
         </DatePicker>

         <TimePicker 
            v-if="form.type === 'timepicker'"
            :type="form.form_type || 'time'" 
            :value="form_data_[form.model]" 
            :format="form.format || 'HH:mm'" 
            :placement="form.placement || 'bottom-end'" 
            :placeholder="form.placeholder"
            :steps="form.steps || [1,5]"
            @on-change="handleChange($event,form)">
         </TimePicker>

         <Radio
            v-if="form.type === 'radio'"
            :classes="form.classes"
            :name="form.model"
            v-model="form_data_[form.model]"
            :action="form.name"
            :placeholder="form.placeholder"
            :options="form.options"
            @input="validateItem(form)"
         />

         <Upload 
            v-if="form.type === 'upload'"
            :label="form.label"
            :name="form.model"
            :accept="form.accept" 
            :multiple="form.multiple" 
            v-model="form_data_[form.model]"
            @file-selected="forwardEvent('file-selected',$event)"
         />

         <ColorPicker 
            v-if="form.type === 'color'"
            v-model="form_data_[form.model]" 
            :hue="form.hue || true" 
            :alpha="form.alpha || false"
            :recommend="form.recommend || false"
            :colors="form.colors"
            @on-change="validateItem(form)"
         />

         <Rate 
            v-if="form.type === 'rate'"
            v-model="form_data_[form.model]" 
            :allow-half="form.allow_half || false"
            :icon="form.icon"
            :character="form.character"
            @input="validateItem(form)"
         />

         <Slider 
            v-if="form.type === 'slider'"
            v-model="form_data_[form.model]" 
            :step="form.step" 
            :min="form.min || 0" 
            :max="form.max || 100"
            :show-stops="form.show_stops"
            :range="form.range"
            :marks="form.marks"
            @on-change="validateItem(form)"
         ></Slider>

         <Location
            v-if="form.type === 'location'"
            :name="form.model"
            :model="form_data_[form.model]" 
            :placeholder="form.placeholder" 
            v-model="form_data_[form.model]"
            @on-change="validateItem(form)"
         ></Location>

         <FormTable
            v-if="form.type === 'form-table'" 
            :table="form.table" 
            :forms="form.forms" 
            v-model="form_data_[form.model]"
         />

         <FormSelect
            v-if="form.type === 'form-select'" 
            :options="form.options" 
            :name="form.model" 
            v-model="form_data_[form.model]"
         />

         <CheckboxGroup
            v-if="form.type === 'checkbox-group'"
            :classes="form.classes"
            :name="form.model"
            v-model="form_data_[form.model]"
            :action="form.name"
            :placeholder="form.placeholder"
            :options="form.options"
            :model="form_data_[form.model]"
            @input="validateItem(form)"
         />

         <label 
            v-if="form.type !== 'checkbox' && form.type != 'button' && form.type != 'upload' && form.sub_label_bottom"
            class="small-label-bottom" 
         >{{form.sub_label_bottom}}</label>
         <!-- Validation Error -->
         <div class="form-err" v-html="form.err"></div>
      </div>
   </form>
</template>

<script>
import {Select, Option, OptionGroup} from './select/'
import {TimePicker} from './date-picker/index'

export default {
   created(){
      Event.$on('form:validation_error',(payload) => {
         let errors = payload.errors
         for (const form of this.forms) {
            for (let i = 0; i < errors.length; i++) {
               const error = errors[i];
               
               if(form.model === error.field){
                  form.err = error.message
               }
            }
         }
         this.$forceUpdate();
      })
   },
   components: {
      Checkbox: () => import("./checkbox"),
      SwitchComponent: () => import("./switch"),
      CheckboxGroup: () => import("./checkbox-group"),
      Radio: () => import("./radio"),
      TextArea: () => import("./textarea"),
      InputText: () => import("./text"),
      ColorPicker: () => import("./color-picker/index"),
      DatePicker: () => import("./date-picker/index"),
      Slider: () => import("./slider/index"),
      Rate: () => import("./rate/index"),
      Upload: () => import("./upload"),
      Location: () => import("./location"),
      FormTable: () => import("./form-table"),
      FormSelect: () => import("./form-select"),
      Mobile: () => import("./mobile"),
      Select,
      Option,
      OptionGroup,
      TimePicker
   },
   props: {
      forms: {
         type: Array,
         default: function(){
            return []
         }
      },
      class_binding: {
         type: String,
         default: ''
      },
      name:{
         type: String,
         default: ''
      },
      form_data: {
         type: Object,
         default: function(){
            return {}
         }
      }
   },
   watch:{
      forms(oldVal,newVal){
         this.form_data_ = utils.generateFormData(newVal)
      },
      form_data(oldVal,newVal){
         this.form_data_ = this.form_data
      }
   },
   data () {
      return {
         form_data_: this.form_data,
         hasErrors: false,
         remoteData: {}
      }
   },
   methods: {
      handleSelectChange(data,form){
         if(data){
            this.form_data_[form.model] = data
         }
      },
      debounce(search, debounceDuration = 300){
         if(this.timeoutId !== null)
         {
            clearTimeout(this.timeoutId);
         }
         this
      },
      async handleRemote(query,form){
         if(form.debounce !== null){clearTimeout(this.timeoutId);}

         // Debounce input - Input allowe only after one second
         form.debounce = await setTimeout(async () => {
            if(query !== ''){
               if(form.remote_method){
                  let options = []
                  options = await form.remote_method(query)
      
                  if(Array.isArray(options)){
                     form.options = options
                  }
               }
            }
         }, 1000);
      },
      resetForms(){
         this.form_data_ = utils.generateFormData(this.forms)
      },
      forwardEvent(name,e){
         this.$emit(name,e)
      },
      btnClick(name){
         this.$emit('button-click',{ref: this,name})
      },
      submitForm(){
         if(this.isValid()){
            this.$emit('submit',{})
         }
      },
      handleChange (date,form) {
         this.form_data_[form.model] = date;
         this.validateItem(form)
      },
      onSelectChange(form){
         Event.$emit('select-field-changed',{form,data: this.form_data_[form.model]})
         this.validateItem(form)
      },
      observerClean (obj) {
         return Object.keys(obj).reduce(
            (res, e) => Object.assign(res, { [e]: obj[e] }),
            {}
         )
      },
      async validateItem(form){
         this.$emit('form-input',form)
         
         form.err = ''
         let obj = {
            [`${this.name}`]: this.form_data_
         }

         // store the form data to allow for validation outside this component
         global_forms = {...global_forms, ...this.observerClean(obj)}
         if(form.validation){
            let result = await validate(this.form_data_[form.model], form.validation, { name: form.label }), err = undefined

            if (!result.valid) {
               this.hasErrors = true
               err = result.errors[0]
            }

            form.err = err
            this.$forceUpdate();
         }
      },
      async isValid() {
         this.hasErrors = false

         for (let i = 0; i < this.forms.length; i++) {
            const form = this.forms[i];
            await this.validateItem(form)
         }

         if(!this.hasErrors){
            this.$emit('submit',this.form_data_)
            return true
         }else{
            $notify('warning','Validation Errors','Fix form inputs with errors before proceeding',30)
            return false
         }
      },
   },
   mounted(){
   },
   beforeDestroy(){
      delete global_forms[this.name]
   }
}
</script>